<template>
    <div class="user-edit">
        <h2 class="page-title">Award                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    - <span class="fw-semi-bold">Detail</span></h2>
        <Widget :title="(isNew ? 'New' : 'Edit') + ' award'">
            <Loader v-if="!isNew && isReceiving" :size="40"></Loader>
            <Form v-else>
                <div class="form-group row">
                    <label class="col-md-2" for="name">Award title</label>
                    <div class="col-md-5">
                        <input class="form-control" id="name" type="text" :value="award.title" @change="updateAwardProperty($event, 'title')"/>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-2" for="description">Award description</label>
                    <div class="col-md-5">
                        <textarea class="form-control" id="description" type="text" :value="award.description"
                                  @change="updateAwardProperty($event, 'description')"/>
                    </div>
                </div>

                <div v-for="(awardAction, i) in awardActionsAndThresholds">
                    <div class="form-group row">
                        <label class="col-md-2" for="threshold">
                            Threshold {{i+1}}
                            <i class="fa fa-close ml-4"  v-if="awardActionsAndThresholds.length>1" @click="removeAwardAction(i)"/>
                        </label>

                        <div class="col-md-5">
                            <input class="form-control" id="threshold" type="number" v-model="awardAction.threshold"
                                   />
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-2" for="awardAction">Action {{i+1}}</label>
                        <v-select class="col-md-5"
                                  :clearable="false"
                                  required
                                  id="awardAction"
                                  v-model="awardAction.action"
                                  :options="awardActions"
                        />
                    </div>
                </div>
                <b-button variant="outline-info" class="mb-3 mb-xs mr-xs"
                          @click="addNewAwardAction"
                          v-if="awardActionsAndThresholds.length < awardActions.length">
                    Add new action
                </b-button>

                <div class="form-group row">
                    <label class="col-md-2" for="recurrenceUM">Recurrence</label>
                    <v-select class="col-md-5"
                              :clearable="false"
                              required
                              id="recurrenceUM"
                              v-model="award.recurrence"
                              :options="awardRecurrence"
                    />
                </div>
                <div class="form-group row">
                    <label class="col-md-2">Award image</label>
                    <div class="col-md-5">
                        <b-button variant="outline-info" class="mb-3 mb-xs mr-xs"
                                  v-b-modal.add-award-icon-modal>
                            Choose icon
                        </b-button>
                        <div>
                            <img style="max-width:100px" :src="pickedAwardIcon"/>
                        </div>
                    </div>

<!--                    <div class="col-md-5">-->
<!--                        <input-->
<!--                                style="display:none"-->
<!--                                accept="image/*" @change="onChangeInputImage"-->
<!--                                id="fileupload"-->
<!--                                type="file" name="file" class="display-none"-->
<!--                        />-->
<!--                        <div class="fileinput fileinput-new fileinput-fix">-->
<!--                            <div class="fileinput-new thumbnail">-->
<!--                                <div v-if="awardPhoto">-->
<!--                                    <img style="max-width:200px" :src="awardPhoto.preview"/>-->
<!--                                </div>-->
<!--                                <div v-else-if="!isNew">-->
<!--                                    <img style="max-width:200px" :src="award.downloadUrl"/>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div>-->
<!--                            <b-button type="button" variant="default" class="mt-sm">-->
<!--                                <label for="fileupload">-->
<!--                                    Select image-->
<!--                                </label>-->
<!--                            </b-button>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>
                <div class="abc-checkbox abc-checkbox-primary mb-4">
                    <input type="checkbox"
                           id="isPublic"
                           :checked="award.public == true"
                           @change="togglePublic()"
                    />
                    <label for="isPublic">Active</label>
                </div>
                <div class="abc-checkbox abc-checkbox-primary mb-4" v-if="showGlobalOption()">
                    <input type="checkbox"
                           id="isGlobal"
                           :checked="award.global == true"
                           @change="toggleGlobal()"
                    />
                    <label for="isGlobal">Global</label>
                </div>
                <b-alert class="alert-sm w-25" variant="danger" :show="errorsList.length > 0" :key="error"
                         v-for="error in errorsList">
                    {{error}}
                </b-alert>
                <b-button-toolbar>
                    <b-button variant="success"
                              @click="saveAward()">
                        <Loader v-if="isUpdating"></Loader>
                        <span v-else>Save</span>
                    </b-button>

                    <b-button variant="default" @click="goBack()">
                        Back
                    </b-button>

                </b-button-toolbar>
            </Form>
        </Widget>
        <AddAwardIcon />

    </div>
</template>


<script>
  import {mapActions, mapState} from "vuex";
  import moment from "moment";
  import DatePicker from 'vue2-datepicker';
  import {firestore} from "../../main";
  import Loader from "../../components/Loader/Loader";
  import vSelect from "vue-select";
  import Vue from "vue";
  import AddAwardIcon from "./AddAwardIcon";


  export default {
    name: "AddAward",
    components: { Loader, vSelect, DatePicker, AddAwardIcon },
    data(){
      return {
        errorsList: [],
        awardRecurrence: [
          {code: 'DAILY', label:'Daily'},
          {code: 'WEEKLY', label:'Weekly'},
          {code: 'NONE', label:'None'}
        ],
        awardActions: [
          {code: 'RECEIVE_COMMENT', label:'Receive comment'},
          {code: 'WRITE_COMMENT', label:'Write comment'},
          {code: 'GIVE_STAR', label:'Give star'},
          {code: 'RECEIVE_STAR', label:'Receive star'}
        ],
        awardActionsAndThresholds: [
          {threshold: null, action: null}
        ],
        awardPhoto: null,
      }
    },
    computed: {
      ...mapState("awards", ["awards", "pickedAwardIcon", "isReceiving", "isUpdating"]),
      ...mapState("countries", ["selectedCountry", "countries"]),
      ...mapState("auth", ["currentUser"]),
      isNew() { return this.getId() === -1},
      award() {
        return this.findAward(this.getId()) || {}
      }
    },
    methods: {
      ...mapActions("awards", ["uploadAwardFile", "createAwardRequest", "getAwardsRequest", "updateAwardRequest",
        "deleteAwardFile", "pickIcon"]),
      ...mapActions("auth", ["fetchCurrentUser"]),
      onChangeInputImage(e) {
        const reader = new FileReader();
        const file = e.target.files[0];
        reader.onloadend = () => {
          file.preview = reader.result;
          file.toUpload = true;
          Vue.set(this, 'awardPhoto', file);
        };
        reader.readAsDataURL(e.target.files[0]);
      },
      async saveAward(){
        this.errorsList = [];

        if(this.award.title == null){
          this.errorsList.push('Award title is required!')
        }
        if(this.award.recurrence == null){
          this.errorsList.push('Award recurrence is required! Please select "None" is no option is suitable')
        }
        if(this.pickedAwardIcon == null && this.award.downloadUrl == null){
          this.errorsList.push('Award image file is required!')
        }

        for(let i in this.awardActionsAndThresholds){
          const awardActThr = this.awardActionsAndThresholds[i];
          if(awardActThr.action == null || awardActThr.threshold == null || awardActThr.threshold < 1){
            this.errorsList.push('Award actions and thresholds are required! Thresholds must be positive integers!');
          }
        }

        const awardActions = this.awardActionsAndThresholds.map(a => { return {action: a.action.code, threshold: a.threshold}})

        if(this.errorsList.length == 0) {

          if(this.isNew) {
            // const fileResponse = await this.uploadAwardFile({tenantId: this.selectedCountry.id, file: this.awardPhoto})
            await this.createAwardRequest({
              award: {
                title: this.award.title,
                description: this.award.description ? this.award.description : null,
                actions: awardActions,
                recurrence: this.award.recurrence.code,
                public: this.award.public ? this.award.public : false,
                global: this.award.global ? this.award.global : false,
                // fileId: fileResponse.fileId,
                downloadUrl: this.pickedAwardIcon,
                tenantId: this.award.global ? null : this.selectedCountry.id
              },
              $toasted: this.$toasted
            })
            // this.awardPhoto = null;
          } else {
            // let fileResponse = null;
            // if(this.awardPhoto != null) {
            //   fileResponse = await this.uploadAwardFile({
            //     tenantId: this.selectedCountry.id,
            //     file: this.awardPhoto
            //   })
            // }
            // const previousFileId = this.award.fileId;
            await this.updateAwardRequest({
              id: this.award.id,
              award: {
                id: this.award.id,
                title: this.award.title,
                description: this.award.description ? this.award.description : null,
                actions: awardActions,
                recurrence: this.award.recurrence.code,
                public: this.award.public ? this.award.public : false,
                global: this.award.global ? this.award.global : false,
                // fileId: fileResponse ? fileResponse.fileId : this.award.fileId,
                downloadUrl: this.pickedAwardIcon ? this.pickedAwardIcon : this.award.downloadUrl,
                tenantId: this.award.global ? null : this.award.tenantId
              },
              $toasted: this.$toasted
            })

            // if(fileResponse != null){
            //   await this.deleteAwardFile({tenantId: this.award.tenantId, fileId: previousFileId})
            // }
          }
          this.$router.replace('/app/content/awards');

        }
      },
      findAward(id) {
        let award = this.awards ? this.awards.find(b => b.id === id) : null
        if(award != null) {
          this.pickIcon(award.downloadUrl);

          this.awardActionsAndThresholds = award.actions.map(a =>
          { return {threshold: a.threshold, action: this.awardActions.filter(act => act.code == a.action)[0]}});

          return Object.assign({}, award, {
            action: this.awardActions.filter(a => a.code == award.action)[0],
            recurrence: this.awardRecurrence.filter(r => r.code == award.recurrence)[0]
          });
        } else {
          this.pickIcon(null);
        }
        return award;
      },
      getId() {
        return this.$route.params.id || -1;
      },
      updateAwardProperty(value, key) {
        let award = this.award;

        award[key] = value.target.value;
      },
      updateAwardSelectProperty(value, key) {
        let award = this.award;

        award[key] = value;
      },
      goBack() {
        this.$router.replace('/app/content/awards');
      },
      togglePublic(){
        let award = this.award;
        award.public = (award.public == null || award.public == false) ? true : false
      },
      toggleGlobal(){
        let award = this.award;
        award.global = (award.global == null || award.global == false) ? true : false
      },
      showGlobalOption(){
        if(this.currentUser) {
          const userAuthorities = this.currentUser.userAuthorities;
          const rootAuthority = userAuthorities.filter(a => a.role == 'ROLE_ROOT')
          if (rootAuthority.length > 0) {
            return true;
          }
        }
        return false;
      },
      addNewAwardAction(){
        this.awardActionsAndThresholds.push({threshold: null, action: null})
      },
      removeAwardAction(i){
        this.awardActionsAndThresholds.splice(i,1);
      },
    },
    async mounted() {
      if(this.currentUser == undefined){
        await this.fetchCurrentUser();
      }
      if(this.currentUser != undefined){
        const selectedCountryId = this.currentUser.selectedCountryId;
        await this.getAwardsRequest(selectedCountryId);
      }
    }
  }
</script>

<style scoped>

</style>
